// Aviso fijo del wizard: icono de alerta, el mensaje y, si la hay, la acción que lo resuelve.
import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

export function WizardWarningNotice({
    children,
    action,
}: {
    children: ReactNode;
    action?: ReactNode;
}) {
    return (
        <div
            role="alert"
            className="flex items-start gap-3 rounded-lg border border-warning-soft-border bg-warning-soft p-3 text-warning"
        >
            <AlertTriangle className="mt-0.5 size-4 flex-none" aria-hidden />
            <div className="min-w-0 flex-1 text-[12px] leading-relaxed">{children}</div>
            {action}
        </div>
    );
}
